var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.key,
      style: _vm.composante.typeCategorieGEMRCNId
        ? "border-left:4px solid " +
          _vm.configurationGEMRCN(_vm.composante.typeCategorieGEMRCNId).couleur
        : ""
    },
    [
      _vm.enChargement
        ? _c(
            "div",
            {
              staticClass: "composante-container",
              staticStyle: { "text-align": "center" }
            },
            [
              _c("img", {
                staticStyle: { height: "80px", "margin-left": "-8px" },
                attrs: {
                  alt: "en attente",
                  src: "/assets/images/spinners/cooking-blue-court.gif"
                }
              })
            ]
          )
        : _vm.composante.recetteId
        ? _c(
            "div",
            {
              class: !_vm.mode
                ? "composante-container"
                : "composante-container apercu"
            },
            [
              !_vm.mode
                ? _c(
                    "div",
                    { staticClass: "flex-center-space-between" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "16px",
                            overflow: "hidden",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                cursor: "default",
                                color: "#BFBFBF"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.composanteNom(
                                      _vm.composante.composanteId
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      !_vm.lectureSeule
                        ? [
                            _c(
                              "div",
                              { staticStyle: { "white-space": "nowrap" } },
                              [
                                _vm.peutDupliquer
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: "Dupliquer la recette"
                                            },
                                            expression:
                                              "{ content: 'Dupliquer la recette'}"
                                          }
                                        ],
                                        staticClass: "btn btn-success",
                                        staticStyle: {
                                          padding: "0 4px",
                                          "border-radius": "8px",
                                          transform: "scale(0.7)",
                                          "margin-right": "-1px"
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.dupliquerRecette({
                                              serviceId: _vm.service.id,
                                              composanteId:
                                                _vm.composante.composanteId,
                                              recetteId:
                                                _vm.composante.recetteId
                                            })
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-clone" })]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: "Changer la recette"
                                        },
                                        expression:
                                          "{ content: 'Changer la recette'}"
                                      }
                                    ],
                                    staticClass: "btn btn-primary",
                                    staticStyle: {
                                      padding: "0 4px",
                                      "border-radius": "8px",
                                      transform: "scale(0.7)",
                                      "margin-right": "-5px"
                                    },
                                    attrs: { type: "button" },
                                    on: { click: _vm.afficherModalRecettes }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-exchange-alt"
                                    })
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: "Effacer la recette"
                                        },
                                        expression:
                                          "{ content: 'Effacer la recette'}"
                                      }
                                    ],
                                    staticClass: "btn btn-danger",
                                    staticStyle: {
                                      padding: "0 6.5px",
                                      "border-radius": "8px",
                                      "margin-left": "4px",
                                      transform: "scale(0.7)"
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.effacerLaRecette({
                                          serviceId: _vm.service.id,
                                          composanteId:
                                            _vm.composante.composanteId,
                                          cleComposee:
                                            _vm.composante.cleComposee
                                        })
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              !_vm.mode
                ? _c(
                    "div",
                    { staticStyle: { "margin-top": "-7px", height: "12px" } },
                    [
                      _vm.regimeNom
                        ? _c(
                            "span",
                            {
                              staticClass: "bold600 texteRestriction",
                              staticStyle: { "font-size": "10px" }
                            },
                            [_vm._v(_vm._s(_vm.regimeNom))]
                          )
                        : _vm._e(),
                      _vm.textureNom
                        ? _c(
                            "span",
                            {
                              staticClass: "bold600 texteRestriction",
                              staticStyle: { "font-size": "10px" }
                            },
                            [_vm._v(_vm._s(_vm.textureNom))]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "flex-center-space-between",
                  staticStyle: { "align-items": "flex-start" }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { style: !_vm.mode ? "height:45px;" : "height:30px;" },
                      [
                        _c(
                          "div",
                          {
                            class: _vm.composante.cotationManquante
                              ? "warningText"
                              : "",
                            staticStyle: {
                              height: "30px",
                              "overflow-y": "hidden",
                              display: "flex",
                              "flex-direction": "column",
                              "justify-content": "center"
                            }
                          },
                          [
                            _c("RecettePopUpIngredients", {
                              staticStyle: { display: "block", height: "30px" },
                              attrs: {
                                estLien: true,
                                recetteId: _vm.composante.recetteId,
                                estDeclinaisonNonPersonnalisee:
                                  _vm.recetteEstDeclinaison(
                                    _vm.composante.recetteId
                                  ) &&
                                  !_vm.recetteEstDeclinaisonPersonnalisee(
                                    _vm.composante.recetteId
                                  ),
                                recetteNom: _vm.recetteNom(
                                  _vm.composante.recetteId
                                ),
                                serviceId: _vm.service.id,
                                typeConviveId: _vm.menu.conviveTypeId,
                                effectif: _vm.composante.effectif,
                                texteClass: _vm.composante.cotationManquante
                                  ? "warningText"
                                  : ""
                              },
                              on: {
                                "recette-enregistree": function($event) {
                                  return _vm.recetteEnregistree(
                                    _vm.menu,
                                    _vm.composante,
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        !_vm.mode && _vm.composante.typeCategorieGEMRCNId
                          ? _c("div", [
                              !_vm.categorieGEMRCNDansRecette(
                                _vm.composante.recetteId,
                                _vm.composante.typeCategorieGEMRCNId
                              )
                                ? _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value:
                                          "La recette sélectionnée ne correspond pas à la catégorie GEMRCN : " +
                                          _vm.configurationGEMRCN(
                                            _vm.composante.typeCategorieGEMRCNId
                                          ).nom,
                                        expression:
                                          "'La recette sélectionnée ne correspond pas à la catégorie GEMRCN : ' + configurationGEMRCN(composante.typeCategorieGEMRCNId).nom"
                                      }
                                    ],
                                    staticClass:
                                      "fas fa-exclamation-triangle text-warning"
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.configurationGEMRCN(
                                        _vm.composante.typeCategorieGEMRCNId
                                      ).nom,
                                      expression:
                                        "configurationGEMRCN(composante.typeCategorieGEMRCNId).nom"
                                    }
                                  ],
                                  style:
                                    "font-size:10px;cursor:default;color:" +
                                    (_vm.composante.typeCategorieGEMRCNId
                                      ? _vm.configurationGEMRCN(
                                          _vm.composante.typeCategorieGEMRCNId
                                        ).couleur
                                      : "#BFBFBF")
                                },
                                [
                                  _c("i", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.abregerTexte(
                                            _vm.configurationGEMRCN(
                                              _vm.composante
                                                .typeCategorieGEMRCNId
                                            ).nom,
                                            50
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "white-space": "nowrap" } },
                    [
                      _vm.composante.recetteId && _vm.composante.prixServi
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "0 4px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.composante.prixServi
                                    .toString()
                                    .replace(".", ",")
                                ) + " €"
                              )
                            ]
                          )
                        : _vm.composante.recetteId && !_vm.composante.prixServi
                        ? _c("ComposantePrix", {
                            attrs: { composante: _vm.composante },
                            on: {
                              "prix-par-convive": function($event) {
                                return _vm.prixParConvive(
                                  $event,
                                  _vm.service.id
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "flex-center-space-between" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.recetteListeAllergenes(
                          _vm.composante.recetteId
                        ),
                        expression:
                          "recetteListeAllergenes(composante.recetteId)"
                      }
                    ],
                    staticStyle: {
                      "font-weight": "normal",
                      "font-style": "italic"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.recetteAllergenes(_vm.composante.recetteId)
                        ) +
                        " "
                    )
                  ]
                ),
                !_vm.estSurPlanNeutre
                  ? _c(
                      "div",
                      {
                        staticClass: "input-et-prix-container",
                        staticStyle: {
                          "margin-left": "0",
                          "padding-right": "0"
                        }
                      },
                      [
                        _vm.estPasse(_vm.service.decalageJour)
                          ? _c(
                              "span",
                              [
                                _vm._v("Servi : "),
                                _c("InputNumber", {
                                  ref: "effectifServi",
                                  staticClass: "inputEffectif",
                                  staticStyle: {
                                    height: "17px",
                                    width: "30px",
                                    "padding-left": "0",
                                    "text-align": "left"
                                  },
                                  attrs: {
                                    typeFiltre: "quantiteEntiere",
                                    zeroSiVide: true,
                                    readonly:
                                      /*estPasse(service.decalageJour + 7) || */ _vm
                                        .composante.typeVerrou ||
                                      _vm.lectureSeule > 0
                                  },
                                  on: {
                                    move: _vm.moveCase,
                                    input: _vm.effectifChanged
                                  },
                                  model: {
                                    value: _vm.composante.effectifServi,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.composante,
                                        "effectifServi",
                                        $$v
                                      )
                                    },
                                    expression: "composante.effectifServi"
                                  }
                                }),
                                _vm.composante.typeVerrou
                                  ? _c("i", {
                                      staticClass: "fas fa-lock",
                                      staticStyle: { "margin-right": "15px" },
                                      attrs: {
                                        title: "Verrouillé par le portage"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          [
                            _vm._v("Prévu : "),
                            _c("InputNumber", {
                              ref: "effectifPrevu",
                              staticClass: "inputEffectif",
                              staticStyle: {
                                height: "17px",
                                width: "30px",
                                "padding-left": "0",
                                "text-align": "left"
                              },
                              attrs: {
                                typeFiltre: "quantiteEntiere",
                                zeroSiVide: true,
                                readonly:
                                  _vm.estPasse(_vm.service.decalageJour) ||
                                  _vm.composante.typeVerrou ||
                                  _vm.lectureSeule > 0
                              },
                              on: {
                                move: _vm.moveCase,
                                input: _vm.effectifChanged
                              },
                              model: {
                                value: _vm.composante.effectif,
                                callback: function($$v) {
                                  _vm.$set(_vm.composante, "effectif", $$v)
                                },
                                expression: "composante.effectif"
                              }
                            }),
                            _vm.composante.typeVerrou
                              ? _c("i", {
                                  staticClass: "fas fa-lock",
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: { title: "Verrouillé par le portage" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        : !_vm.mode
        ? _c(
            "div",
            {
              staticClass: "composante-container",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "flex-direction": "column",
                "justify-content": "center"
              }
            },
            [
              _c("div", { staticStyle: { display: "inline-flex" } }, [
                !_vm.lectureSeule
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: { content: "Ajouter une recette" },
                            expression: "{ content: 'Ajouter une recette'}"
                          }
                        ],
                        staticClass: "btn btn-primary",
                        staticStyle: {
                          padding: "0 4px",
                          "border-radius": "8px"
                        },
                        attrs: { type: "button" },
                        on: { click: _vm.afficherModalRecettes }
                      },
                      [_c("i", { staticClass: "fas fa-plus" })]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticStyle: {
                      cursor: "default",
                      "font-size": "14px",
                      "margin-left": "4px",
                      "padding-top": "2px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.composanteNom(_vm.composante.composanteId))
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "regime-texture-container" }, [
                _vm.regimeNom
                  ? _c("span", { staticClass: "bold600 texteRestriction" }, [
                      _vm._v(_vm._s(_vm.regimeNom))
                    ])
                  : _vm._e(),
                _vm.textureNom
                  ? _c("span", { staticClass: "bold600 texteRestriction" }, [
                      _vm._v(_vm._s(_vm.textureNom))
                    ])
                  : _vm._e()
              ]),
              !_vm.mode && _vm.composante.typeCategorieGEMRCNId
                ? _c("div", [
                    _c(
                      "span",
                      {
                        style:
                          "font-size:10px;cursor:default;color:" +
                          (_vm.composante.typeCategorieGEMRCNId
                            ? _vm.configurationGEMRCN(
                                _vm.composante.typeCategorieGEMRCNId
                              ).couleur
                            : "#BFBFBF")
                      },
                      [
                        _c("i", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.configurationGEMRCN(
                                  _vm.composante.typeCategorieGEMRCNId
                                ).nom
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _c(
            "div",
            {
              staticClass: "composante-container apercu",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "flex-direction": "column",
                "justify-content": "center"
              }
            },
            [_vm._v("Pas de recette")]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }